import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './screens/Home';
import NotFound from './screens/NotFound';
import WpEvalRun from './screens/WpEvalRun';
import CREvalRun from './screens/CREvalRun';
import Datasets from './screens/Datasets';
import ResultsBrowser from './screens/ResultsBrowser';
import EvaluationsDashboard from './screens/EvaluationsDashboard';
import EvaluationDetail from './screens/EvaluationDetail';
import PromptManagement from './screens/PromptManagement';
import AttributeMappingTable from './components/AttributeMappingTable';
import VariableRegistry from './screens/VariableRegistry';
import ProductManagement from './screens/ProductManagement';
import AuthGate from './components/AuthGate';

const App = () => {

  return (
    <AuthGate>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/evaluation" element={<Home />} />
        <Route path="/datasets" element={<Datasets />} />
        <Route path="/wpevalrun" element={<WpEvalRun />} />
        <Route path="/crevalrun" element={<CREvalRun />} />
        <Route path="/evaluations" element={<EvaluationsDashboard />} />
        <Route path="/evaluations/:jobId" element={<EvaluationDetail />} />
        <Route path="/results" element={<ResultsBrowser />} />
        <Route path="/admin/prompts" element={<PromptManagement />} />
        <Route path="/admin/mappings" element={<AttributeMappingTable />} />
        <Route path="/admin/variables" element={<VariableRegistry />} />
        <Route path="/admin/products" element={<ProductManagement />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={5000} />
    </AuthGate>
  );
};

export default App;